<!-- 
	公告组件 Z12
	1、公告设置：内容颜色、背景颜色
	2、组件样式：上边距、下边距
-->
<template>
	<view class="f_r_c_c" :style="wrapperStyle" style="padding-left: 20rpx;">
		<view  style="background-color: #dcecea;border-radius: 15px;color: #3a8a79;text-align: center;padding: 8rpx 20rpx;">公告</view>
		<up-notice-bar :text="announceTitle" 
		direction="column" 
		:icon="icon"
		fontSize="28rpx"
		:bgColor="data.backgroundColor" 
		:color="data.contentColor" 
		style="padding: 20rpx;"
		@click="navigateTo"></up-notice-bar>
	</view>
</template>
<!--
"decorateNoticeBo": {
	"id": "49cb7084740711f0a3479c5c8ebcfe65",
	"companyId": "1",
	"shopId": "1",
	"decorateId": "ad0507d26f9f11f0a3479c5c8ebcfe65",
	"decorateModuleId": "49ca98f5740711f0a3479c5c8ebcfe65",
	"contentColor": "#212121",
	"backgroundColor": "#FFFFFF",
	"upMargin": "0",
	"bottomMargin": "0",
	"createTime": "2025-08-08 11:25:10"
}
-->

<script setup>
	import { onLoad, onShow } from '@dcloudio/uni-app';
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	import {getAnnounceInfoThreeNew} from "@/api/mine/mine.js";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	
	onLoad(() => {
		// 获取公告信息
		getInfo()
	})
	const icon = ref("")
	const announceTitle = ref([]) // 公告标题数组集合
	const announceTitleIndex = ref([]) // 公告ID数组集合
	
	// 获取公告信息
	function getInfo() {
		let param = {};
		param.platId = ctx.platId || 1;
		
		getAnnounceInfoThreeNew(JSON.stringify(param)).then(res => {
			if (res.retCode == 1) {
				let list = res.objs
				list.forEach((item, index) => {
					announceTitle.value.push(item.name)
					announceTitleIndex.value.push(item.id)
				})
			} else {
				uni.showToast({
					title: '请求错误',
					icon: 'none',
					duration: 1500
				});
			}
		}).catch(err => {
			uni.showToast({
				title: '请求异常',
				icon: 'none',
				duration: 1500
			});
		})
	}
	
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//背景颜色
					"backgroundColor": {
						type: String,
						default: '#fdf6ec'
					},			
					//内容颜色
					"contentColor": {
						type: String,
						default: '#f9ae3d'
					},				
					//上边距
					"upMargin": {
						type: Number,
						default: 0
					},				
					//下边距
					"bottomMargin": {
						type: Number,
						default: 0
					}
				}
			}
		}
	})
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		const {
			upMargin,
			bottomMargin,
			backgroundColor,
		} = props.data;
		return `
			margin-top: ${upMargin}px;
			margin-bottom: ${bottomMargin}px;
			background-color: ${backgroundColor};
		`;
	})
	
	/**
	 * 页面跳转
	 * @param {Object} index
	 */
	function navigateTo(index) {
		uni.navigateTo({
		  url: "/pages/announceDetail/announceDetail?id=" + announceTitleIndex.value[index],
		});
	}
	
</script>

<style lang="less" scoped>
	.backColor1{
		background-color: rgb(244, 244, 244);
	}
	.backColor2{
		background-color: rgb(255, 255, 255);
	}
</style>
